// @ts-nocheck
import { type BaseGroupInfo } from "./BaseGroupInfo";

export const NullGroup: BaseGroupInfo = {
    id: null,
    name: null,
};
